import React from 'react';

function Header() {
	return (
		<div className='container header'>
			<div className='block'>
				<h1 className='is-size-1 has-text-black has-text-weight-bold'>
					Meta Tag Generator
				</h1>
				<h2 className='is-size-5 has-text-grey-dark has-text-weight-medium'>
					Meta tags are HTML tag content that provide metadata about your
					website such as description. Meta tags are used by search engines to
					help index and to provide relevant content in their search results
				</h2>
			</div>
		</div>
	);
}

export default Header;
